function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { convertToAnalyticObject } from '../../utils/analytics';
import getListing from '../../utils/getListing';
import { qsToObject } from '../../utils/querystring';
import { usePrevious } from '../../utils/usePrevious';
import { eventDatesRange } from '../Listing/DateRange';
import { get, getPageThemeColors, getColorByTheme, canUseDOM, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { getHostName } from '../atoms/InteractiveMap/utils/getHostName';
import addQueryString, { ANNUAL_FEE, convertQueryParamsToFacetsWithoutPlusReplacement, getAlgoliaTagsList, removeQueryString, splitter } from '../Listing';
import InteractiveGoogleMap from '../atoms/InteractiveMap/InteractiveGoogleMap';
import InteractiveMapFilters from '../atoms/InteractiveMap/InteractiveMapFilters';
import InteractiveMapListing from '../atoms/InteractiveMap/InteractiveMapListing';
import InteractiveMapLayout from '../atoms/InteractiveMap/InteractiveMapLayout';
import CategoryFilters from '../atoms/InteractiveMap/components/CategoryFilters';
import { getItemColor } from '../atoms/InteractiveMap/utils/getItemColor';
import { getTopPicksStorage } from '../atoms/FavouriteBtn/top_picks_apis';
import { idConverter } from '../atoms/FavouriteBtn/FavouriteBtn';
const filterType = 'type';
const withMapModalView = false;
const imageDictionary = 'imageDictionary';
export const moveObjectToFirstPlace = (array, conditionFn) => {
  const index = array.findIndex(conditionFn);
  if (index !== -1) {
    const [object] = array.splice(index, 1);
    array.unshift(object);
  }
  return array;
};
const getFacetNamesValue = filterData => {
  if (filterData) {
    const values = filterData.values.map(filter => {
      const item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      const item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      const facet = item1 || item2 || 'datesRange';
      if (facet === 'maxDelegates') {
        return 'maxDelegatesRangeIndex';
      }
      return facet;
    });
    return values;
  } else {
    return [];
  }
};
const InteractiveMap = _ref => {
  let {
    fields,
    children,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const language = sitecoreContext && sitecoreContext.language;
  const currentLang = get(sitecoreContext, 'language');
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const location = useLocation();
  let history = useHistory();
  // max number algolia can sent by 1 request
  const pagesize = 1000;
  const mainSearchIndex = get(fields, 'data.datasource.mainSearchIndex.jss.fields.IndexName.value', '');
  const mainHitsPerPage = get(fields, 'data.datasource.hitPerPage.jss.value', 10);
  const mainTitle = get(fields, 'data.datasource.title.jss.value') || '';
  const categories = get(fields, 'data.datasource.children') || [];
  const defaultMapZoom = Number(get(fields, 'data.datasource.defaultMapZoom.jss.value')) || 10;
  const centreMapLatitude = Number(get(fields, 'data.datasource.centreMapLatitude.jss.value')) || 25.2048493;
  const centreMapLongitude = Number(get(fields, 'data.datasource.centreMapLongitude.jss.value')) || 55.2707828;
  const dictionary = get(fields, 'data.dictionary');
  const [nestedFilters, setNestedFilters] = React.useState({
    values: []
  });
  const [result, setResult] = React.useState();
  const [defaultFacets, setdefaultFacets] = React.useState();
  const [page, setpage] = React.useState(0);
  const [resetFilter, setResetFilter] = React.useState(false);
  const [setFilters, applySetFilters] = React.useState(false);
  const [chosenTypes, setChosenTypes] = React.useState([]);
  const [removeFilterLogic, setRemoveFilterLogic] = React.useState(false);
  const [firstLoad, setFirstLoad] = React.useState(true);
  const [facets, setFacets] = React.useState([]);
  const [facetsStats, setFacetsStats] = React.useState({});
  const [nbHits, setNbHits] = React.useState(0);
  const [nbPages, setNbPages] = React.useState(0);
  const [hits, setHits] = React.useState([]);
  const [allHits, setAllHits] = React.useState([]);
  const [listingHits, setListingHits] = React.useState([]);
  const [resetAllFilters, setResetAllFilters] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [mapApiReady, setMapApiReady] = React.useState(false);
  const [mapState, setMapState] = React.useState({});
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [allowSearch, setAllowSearch] = React.useState(false);
  const [activeListingItemId, setActiveListingItemId] = React.useState(null);
  const [nestedFiltersHasPreselectedTags, setNestedFiltersHasPreselectedTags] = React.useState(false);
  const [activePopupItem, setActivePopupItem] = React.useState(null);
  const [activeTopPicks, setActiveTopPicks] = React.useState([]);
  const checkboxes = React.useRef(null);
  const defaultTypeValues = React.useRef([]);
  const requestSettingsForSearch = React.useRef({
    facets: [],
    facetFilters: null,
    index: ''
  });
  const host = canUseDOM ? window.location.hostname : '';
  const prevChosenType = usePrevious(chosenTypes);
  const showLabel = getDictionaryItem(dictionary, 'Show') || 'show';
  const resultsLabel = getDictionaryItem(dictionary, 'Results') || 'results';
  const clearAllLabel = getDictionaryItem(dictionary, 'ClearAll') || 'clear all';
  const selectAllLabel = getDictionaryItem(dictionary, 'ShowAll') || 'show all';
  const Cancel = getDictionaryItem(dictionary, 'Cancel') || 'cancel';
  const FiltersCopy = getDictionaryItem(dictionary, 'Filters') || 'filters';
  const day = getDictionaryItem(dictionary, 'Day') || 'day';
  const days = getDictionaryItem(dictionary, 'Days') || 'days';
  const noItemsInLisitng = getDictionaryItem(dictionary, 'noItemsInLisitng') || 'no items in the list';
  const viewAsList = getDictionaryItem(dictionary, 'viewAsList') || 'view as listing';
  const viewMoreAsList = getDictionaryItem(dictionary, 'viewMoreAsList') || 'view more as as list';
  const viewAsMap = getDictionaryItem(dictionary, 'viewAsMap') || 'view as map';
  const listingTitleCommon = getDictionaryItem(dictionary, 'listingTitleCommon') || 'popular around the city';
  const listingTitleSelected = getDictionaryItem(dictionary, 'listingTitleSelected') || "Dicsover's dubai's {count}";
  const lbResultsForDictionary = getDictionaryItem(dictionary, 'lbResultsFor') || 'Results for';
  const lbNoResultsDictionary = getDictionaryItem(dictionary, 'lbNoResults') || 'We could not find any results.';
  const placeholderDictionary = getDictionaryItem(dictionary, 'placeholder') || 'Start typing...';
  const search = {
    IndexName: {
      value: mainSearchIndex
    },
    targetItem: {
      lbResultsFor: {
        value: lbResultsForDictionary
      },
      lbNoResults: {
        value: lbNoResultsDictionary
      },
      placeholder: {
        value: placeholderDictionary
      },
      hitsPerPage: {
        value: mainHitsPerPage
      },
      indexName: {
        value: mainSearchIndex
      }
    }
  };
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    '--m113-interactive-map-background-color': BackgroundColorHex,
    '--m113-interactive-map-background-active-color': ActiveColorHex,
    '--m113-interactive-map-color': ColorHex
  } : {
    '--m113-interactive-map-background-color': selectedPrimaryColor,
    '--m113-interactive-map-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-interactive-map-color': getColorByTheme(selectedPrimaryColor)
  };
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  const generateSearchIndex = index => `${getHostName(host)}${index}_${language}`;
  const getCategorySearchIndex = () => {
    return chosenTypes.length > 1 ? generateSearchIndex(mainSearchIndex) : chosenTypes[0].searchIndex;
  };
  const searchIndexParams = chosenTypes.length ? getCategorySearchIndex() : generateSearchIndex(mainSearchIndex);
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      let topPicks = getTopPicksStorage();
      let topPicksList = topPicks.list || [];
      setActiveTopPicks(topPicksList.map(el => el.itemId));
    }
  }, []);

  // START  CATEGORY LOGIC

  const queryParams = qsToObject(location.search);
  if (Object.keys(queryParams).length !== 0) {
    for (let key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  let facetFilters = convertQueryParamsToFacetsWithoutPlusReplacement(queryParams, true, nestedFilters);
  let algoliaIndexes = chosenTypes.length ? getCategorySearchIndex() : generateSearchIndex(mainSearchIndex);
  const getAllFacetsNames = () => {
    let allFacetsNames = [filterType];
    if (categories.length) {
      categories.map(el => {
        const categoriesFacetsArray = el.filters.values ? getFacetNamesValue(el.filters) : [];
        allFacetsNames = [...allFacetsNames, ...categoriesFacetsArray];
      });
    }
    return allFacetsNames;
  };
  const handleCategoryQuery = function () {
    let removeAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let selectedCheckboxesUrl = [];
    let allFacets = getAllFacetsNames();
    selectedCheckboxesUrl = chosenTypes.map(el => el.value).join(splitter);
    if (removeAll) {
      allFacets.filter((value, index) => allFacets.indexOf(value) === index).forEach(type => {
        removeQueryString(type, history);
      });
    } else {
      if (selectedCheckboxesUrl.length) {
        addQueryString(filterType, replaceUrlPluses(selectedCheckboxesUrl), history);
      } else {
        removeQueryString(filterType, history);
      }
    }
  };
  const listingRequest = function (itemFilters) {
    let getDefaultFacets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setLoading(true);
    let pageNumber = 1;
    let promisesQueue = [];
    let finalResponse = [];
    if (getDefaultFacets) {
      getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
        setdefaultFacets(response.facets);
      }).then(() => {
        setTimeout(() => setLoading(false), 1000);
      });
    } else {
      getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
        if (response.hits) {
          applySetFilters(false);
          setResult(response);
          setFacets(response.facets);
          // setdefaultFacets(response.facets);
          setFacetsStats(response && response.facets_stats);
          setNbHits(response.nbHits);
          setNbPages(response.nbPages);
          finalResponse = [...response.hits];
          finalResponse = finalResponse.filter(el => el._geoloc && el.objectID);
          setHits(finalResponse);
          setAllHits(finalResponse);
          setListingHits(finalResponse);

          // nbPages - max available items per page
          if (pageNumber < response.nbPages) {
            // create array of promisses
            for (let i = 1; i < response.nbPages; i++) {
              const itemFilterCopy = _objectSpread({}, itemFilters);
              itemFilterCopy.page = i;
              promisesQueue.push(itemFilterCopy);
            }
            if (promisesQueue.length) {
              Promise.all(promisesQueue.map(item => {
                getListing(algoliaIndexes, item, algoliaSettings).then(responses => {
                  // summarize all the hits by all request
                  finalResponse = [...finalResponse, ...responses.hits];
                  finalResponse = finalResponse.filter(el => el._geoloc && el.objectID);
                }).then(() => {
                  setHits(finalResponse);
                  setAllHits(finalResponse);
                  setListingHits(finalResponse);
                  setTimeout(() => setLoading(false), 1000);
                }).catch(function (error) {
                  console.log(error);
                });
              }));
            }
          }
        }
      }).then(() => {
        setTimeout(() => setLoading(false), 1000);
        setResetAllFilters(false);
      });
    }
  };
  const handleCategorAllRequest = () => {
    const facetFiltersFromCategory = chosenTypes.length ? chosenTypes.map(el => `type: ${el.value}`) : defaultTypeValues.current.map(el => `type: ${el.value}`);
    const itemFilters = {
      facets: [filterType],
      filters: 'isGeoloc:true',
      facetFilters: [[...facetFiltersFromCategory]],
      hitsPerPage: pagesize,
      page: 0
    };
    listingRequest(itemFilters);
    requestSettingsForSearch.current = {
      facets: [filterType],
      facetFilters: [[...facetFiltersFromCategory]],
      index: searchIndexParams
    };
    handleCategoryQuery(true);
    setRemoveFilterLogic(false);
  };
  React.useEffect(() => {
    if (!withMapModalView && categories.length) {
      let defaultItems = [...categories];
      defaultTypeValues.current = defaultItems.map(el => {
        const item = {
          searchIndex: generateSearchIndex(get(el, 'searchIndex.jss.fields.IndexName.value') || ''),
          value: get(el, 'contentType.type.template.targetItem.value') || '',
          nestedFilters: get(el, 'filters') || [],
          color: get(el, 'colourTheme.item.backgroundColor.jss.value') || 'var(--m113-interactive-map-background-color)'
        };
        return item;
      });
      handleCategorAllRequest();
    }
  }, []);
  React.useEffect(() => {
    if (removeFilterLogic) {
      handleCategorAllRequest();
    }
  }, [removeFilterLogic]);
  const getFacetFiltersFromTypes = () => {
    return chosenTypes.length ? chosenTypes.map(el => `type: ${el.value}`) : defaultTypeValues.current.map(el => `type: ${el.value}`);
  };
  const hasPreselectedTags = nestedItems => {
    const itemsWithPreselectedTags = nestedItems.filter(item => item.preselectedTags && item.preselectedTags.values.length);
    setNestedFiltersHasPreselectedTags(itemsWithPreselectedTags.length ? true : false);
  };
  const submitFilters = (e, key, index, nestedFilters) => {
    handleCategoryQuery(true);
    const selectedItem = {
      searchIndex: generateSearchIndex(e.target.getAttribute('data-search-index') || ''),
      value: e.target.value,
      nestedFilters: nestedFilters.values ? nestedFilters : {
        values: []
      },
      title: e.target.getAttribute('data-mainTitle') || ''
    };
    if (chosenTypes.find(el => el.value === selectedItem.value)) {
      const items = chosenTypes.filter(el => el.value !== selectedItem.value);
      //uncheck categories
      setChosenTypes(items);
      setNestedFilters({
        values: []
      });
      hasPreselectedTags([]);
      setRemoveFilterLogic(true);
    } else {
      //check categories
      setChosenTypes([selectedItem]);
      hasPreselectedTags(selectedItem.nestedFilters.values);

      // filterData  TO DO ADD CHECK FOR NULL
      setNestedFilters(selectedItem.nestedFilters);
    }
    setFirstLoad(false);
  };

  // END  CATEGORY LOGIC

  React.useEffect(() => {
    if (!firstLoad) {
      const queryIndexes = Object.keys(queryParams).filter(k => k.indexOf(`${searchIndexParams}_asc_`) > -1)[0];
      let algoliaIndexes = '';
      if (queryIndexes) {
        algoliaIndexes = queryIndexes;
      } else {
        algoliaIndexes = get(params, 'SearchIndex');
      }
      let tag = 'tags:';
      if (canUseDOM) {
        const hash = window.location.hash;
        const hashvalue = hash.split('#tag=');
        if (hashvalue[1]) {
          tag = 'tags:' + decodeURI(hashvalue[1]);
        }
      }
      const types = getFacetFiltersFromTypes();
      // filterData
      const facetNames = getFacetNamesValue(nestedFilters);
      let filters;
      if (queryParams.datesRange) {
        filters = queryParams.datesRange.split('+').join(' ');
      } else {
        let filterValues = getAlgoliaTagsList(nestedFilters);
        if (filterValues.indexOf(eventDatesRange) > -1) {
          filters = `datesRange.to > ${Date.parse(new Date()) / 1000}`;
        }
        if (~filterValues.indexOf(ANNUAL_FEE) && queryParams[ANNUAL_FEE]) {
          filters = `${queryParams[ANNUAL_FEE]}`.split('+').join(' ');
        }
        var filtersData = [];
        if (filterValues.indexOf('totalHotelRooms') > -1 && queryParams['totalHotelRooms']) {
          filtersData.push(`totalHotelRooms ${queryParams['totalHotelRooms'].split('+').join(' ')}`);
        }
        if (filtersData.length) {
          filters = filtersData.map(query => `(${query})`).join(' AND ');
        }
      }
      if (queryParams.valid) {
        filters = queryParams.valid.split('+').join(' ');
      }
      let itemFilters;
      if (filters) {
        itemFilters = {
          filters: filters ? 'AND (isGeoloc:true)' : 'isGeoloc:true',
          facets: [...facetNames, filterType],
          facetFilters: [[...types], ...facetFilters, [tag]],
          hitsPerPage: pagesize,
          page: 0
        };
      } else {
        itemFilters = {
          facets: [...facetNames, filterType],
          filters: 'isGeoloc:true',
          facetFilters: [[...types], ...facetFilters, [tag]],
          hitsPerPage: pagesize,
          page: 0
        };
      }
      requestSettingsForSearch.current = {
        facets: [filterType],
        facetFilters: [[...types]],
        index: searchIndexParams
      };
      if (resetAllFilters) {
        listingRequest(itemFilters);
      } else if (setFilters) {
        listingRequest(itemFilters);
      } else if (chosenTypes.length && !nestedFiltersHasPreselectedTags && !setFilters) {
        if (JSON.stringify(chosenTypes) !== JSON.stringify(prevChosenType)) {
          itemFilters = {
            facets: [...facetNames, filterType],
            filters: 'isGeoloc:true',
            facetFilters: [[...types], [tag]],
            hitsPerPage: pagesize,
            page: 0
          };
          listingRequest(itemFilters);
        }
      }
    }
  }, [resetAllFilters, resetFilter, setFilters, chosenTypes]);
  React.useEffect(() => {
    //get dafault facets

    if (chosenTypes.length) {
      let tag = 'tags:';
      if (canUseDOM) {
        const hash = window.location.hash;
        const hashvalue = hash.split('#tag=');
        if (hashvalue[1]) {
          tag = 'tags:' + decodeURI(hashvalue[1]);
        }
      }
      const types = getFacetFiltersFromTypes();
      // filterData
      const facetNames = getFacetNamesValue(nestedFilters);
      listingRequest({
        facets: [...facetNames, filterType],
        filters: 'isGeoloc:true',
        facetFilters: [[...types], [tag]],
        hitsPerPage: 1,
        page: 0
      }, true);
    }
  }, [chosenTypes]);
  const resetFilterCallback = () => {
    setFacets(undefined);
    setResult(undefined);
    setNbHits(0);
    setHits([]);
    setListingHits([]);
    setpage(0);
    setResetFilter(true);
  };
  const resetAllFiltersCallback = () => {
    setResetAllFilters(true);
  };

  //when nested filters applies
  const setListingFilter = () => {
    setpage(0);
    setHits([]);
    setListingHits([]);
    applySetFilters(true);
    // setdefaultFacets(result && result.facets);
    setFacetsStats(result && result.facets_stats);
  };
  const updateLocation = () => {
    const defaultLat = Number(centreMapLatitude);
    const defaultLng = Number(centreMapLongitude);
    let markers = [];
    if (hits.length) {
      markers = hits.map(el => {
        el.color = getItemColor(el, defaultTypeValues.current);
        return el;
      });
    }
    setMapState({
      lat: defaultLat,
      lng: defaultLng,
      markers
    });
  };
  React.useEffect(() => {
    if (mapApiReady && !loading) {
      updateLocation();
    }
  }, [mapApiReady, loading, hits]);
  React.useEffect(() => {
    if (!allowSearch && !firstLoad) {
      handleCategorAllRequest();
    }
    if (canUseDOM) {
      const bodyElement = canUseDOM ? document.querySelector('body') : null;
      const htmlElement = canUseDOM ? document.querySelector('html') : null;
      if (bodyElement) {
        if (allowSearch) {
          bodyElement.classList.add('prevent-scroll');
        } else {
          bodyElement.classList.remove('prevent-scroll');
        }
      }
      if (htmlElement) {
        if (allowSearch) {
          htmlElement.classList.add('prevent-scroll');
        } else {
          htmlElement.classList.remove('prevent-scroll');
        }
      }
    }
  }, [allowSearch]);
  const handleResetFiltersFromSearch = () => {
    setChosenTypes([]);
    setResetAllFilters(true);
    setNestedFilters({
      values: []
    });
    setRemoveFilterLogic(true);
  };
  const handleDisableNestedFiltersFromSearch = () => {
    if (chosenTypes.length !== 0) {
      setChosenTypes([]);
      setNestedFilters({
        values: []
      });
    }
  };
  const filterPinsBySearch = searchQuery => {
    if (searchQuery) {
      const searchWords = searchQuery.trim().toLowerCase().split(' ');
      const filteredArticles = allHits.filter(hit => {
        return searchWords.some(word => hit.title && hit.title.toLowerCase().includes(word) || hit.introText && hit.introText.toLowerCase().includes(word));
      });
      console.info(filteredArticles);
      setHits(filteredArticles);
    }
  };
  const handleGetHitsFromMap = mapItemsInViewPort => {
    const loadedItemsFromMap = mapItemsInViewPort.filter(el => el.data).map(el => el.data);
    const updatedListingHits = moveObjectToFirstPlace(loadedItemsFromMap, hit => hit.objectID === activeListingItemId);
    setListingHits(loadedItemsFromMap.length ? updatedListingHits : hits);
  };
  const handleGetActiveItemId = id => {
    setActiveListingItemId(id);
  };
  const apiReady = () => {
    setMapApiReady(true);
  };
  const getActivePopupOnMap = item => {
    setActivePopupItem(item);
  };
  const toggleActiveTopPicks = objectId => {
    const id = idConverter(objectId);
    let topPicks = getTopPicksStorage();
    let topPicksList = topPicks.list || [];
    let list = [...topPicksList.map(el => el.itemId)];
    if (list.includes(id)) {
      const index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      }
    } else {
      list.push(id);
    }
    setActiveTopPicks(list);
  };
  if (fields && !fields.data) {
    console.info('InteractiveMap: check fields.data settings');
    return /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [InteractiveMap component: something went wrong]");
  }
  if (fields && fields.data && !fields.data.datasource) {
    console.info('InteractiveMap: check fields.data.item settings');
    return /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, " [InteractiveMap component: something went wrong]");
  }
  if (!fields) {
    console.info('InteractiveMap component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [InteractiveMap component is empty: please provide data source]");
    }
    return null;
  }
  const leftBar = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InteractiveMapFilters, {
    params: params,
    categories: categories,
    analytics: eventsAnalytics,
    withMapModalView: withMapModalView,
    submitFilters: submitFilters,
    mainTitle: mainTitle,
    rtl: rtl,
    chosenTypes: chosenTypes,
    fields: nestedFilters,
    facets: facets,
    defaultFacets: defaultFacets,
    facetsStats: facetsStats,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    selectAllLabel: selectAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    day: day,
    days: days,
    Cancel: Cancel,
    FiltersCopy: FiltersCopy,
    isTagPage: false,
    lang: currentLang,
    hits: hits,
    dictionary: dictionary,
    imageDictionary: imageDictionary,
    firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
    resetAllFiltersCallback: resetAllFiltersCallback,
    searchIndex: searchIndexParams,
    isNestedFilters: true,
    search: search,
    requestSettingsForSearch: requestSettingsForSearch.current,
    allowSearch: allowSearch,
    handleAllowSearch: value => setAllowSearch(value),
    defaultTypeValues: defaultTypeValues.current,
    handleResetFiltersFromSearch: () => handleResetFiltersFromSearch(),
    activeListingItemId: activeListingItemId,
    handleDisableNestedFiltersFromSearch: () => handleDisableNestedFiltersFromSearch(),
    filterPinsBySearch: searchQuery => filterPinsBySearch(searchQuery),
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: objectId => toggleActiveTopPicks(objectId)
  }), !allowSearch && /*#__PURE__*/React.createElement(CategoryFilters, {
    analytics: eventsAnalytics,
    params: params,
    categories: categories,
    chosenTypes: chosenTypes,
    checkboxesRef: checkboxes,
    withMapModalView: withMapModalView,
    submitFilters: submitFilters,
    rtl: rtl
  }), !allowSearch && /*#__PURE__*/React.createElement(InteractiveMapListing, {
    analytics: eventsAnalytics,
    params: params,
    listingItems: listingHits,
    hits: hits,
    defaultTypeValues: defaultTypeValues.current,
    rtl: rtl,
    noItemsDictionary: noItemsInLisitng,
    viewAsListingDictionary: viewAsList,
    viewMoreAsListingDictionary: viewMoreAsList,
    viewAsMapDictionary: viewAsMap,
    listingTitleCommonDictionary: listingTitleCommon,
    listingTitleSelectedDictionary: listingTitleSelected,
    chosenTypes: chosenTypes,
    mainHitsPerPage: mainHitsPerPage,
    activeListingItemId: activeListingItemId,
    loading: loading,
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: objectId => toggleActiveTopPicks(objectId)
  }));
  const rightBar = /*#__PURE__*/React.createElement(InteractiveGoogleMap, {
    mapState: mapState,
    callback: apiReady,
    handleGetHitsFromMap: hits => handleGetHitsFromMap(hits),
    handleGetActiveItemId: id => handleGetActiveItemId(id),
    dictionary: dictionary,
    defaultMapZoom: defaultMapZoom,
    centreMapLatitude: centreMapLatitude,
    centreMapLongitude: centreMapLongitude,
    analytics: eventsAnalytics,
    params: params,
    rtl: rtl,
    activePopupItem: activePopupItem,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: objectId => toggleActiveTopPicks(objectId)
  });
  return /*#__PURE__*/React.createElement(InteractiveMapLayout, {
    params: params,
    rtl: rtl,
    loading: loading,
    leftBar: leftBar,
    rightBar: rightBar,
    stylesVariables: variables,
    allowSearch: allowSearch
  });
};
export default InteractiveMap;